import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Portfolio from './Portfolio';
import Projects from './Projects';
import Badges from './Badges';
import Magazine from './Magazine';
import Contact from './Contact';
import Footer from './Footer';

function Home() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;

    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return (
    <>
      <Header />
      <Hero />
      <About />
      <Services />
      <Portfolio />
      <Projects />
      <Magazine />
      <Badges />
      <Contact />
      <Footer />
    </>
  );
}

export default Home;